import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyPart = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/parts',

        branches: [],
        branchesLoading: false,

        partCategories: [],
        partCategoriesLoading: false,
        partCategoryLoading: false,

        partTypes: [],
        partTypesLoading: false,
        partTypeLoading: false,

        partBrands: [],
        partBrandsLoading: false,
        partBrandLoading: false,

        partOrigins: [],
        partOriginsLoading: false,
        partOriginLoading: false,

        partQualities: [],
        partQualitiesLoading: false,
        partQualityLoading: false,

        measurements: [],
        measurementsLoading: false,
        measurementLoading: false,

        locations: [],
        locationsLoading: false,
        locationLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,

        partCategories: state => state.partCategories,

        partTypes: state => state.partTypes,

        partBrands: state => state.partBrands,

        partOrigins: state => state.partOrigins,

        partQualities: state => state.partQualities,

        measurements: state => state.measurements,

        locations: state => state.locations,
    },
};
